import React, { useState } from "react";
import { cloudinaryUploadPreset, cloudinaryCloudName } from "../Config/CloudinaryConfig";

const categoryOptions = {
  "Pure Cotton": ["Kanchi Cotton", "Kodali Karuppur"],
  "10 yards": ["Self Plane", "Self Muthukattam", "Vaira Uusi", "Korvai Plane", "Korvai Muthukattam"],
  "One Side Border": ["Self", "Contrast", "Korvai", "Thalampoo"],
  "Double Side Border": ["Big Border","Small Border", "High Border", "Fancy Border", "Border Less"],
  "Fancy Sarees": ["Semisoft Silks", "Mysore Silks"],
  "Bridal": ["Trendy", "Traditional"],
  Lehenga: [],
 
};

const UploadForm = () => {
  const [file, setFile] = useState(null);
  const [section, setSection] = useState("new_arrival");
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [loading, setLoading] = useState(false);

  const isCollection = section === "collection";
  const subCategories = categoryOptions[category] || [];

  const handleUpload = async () => {
    if (!file || !section || !name || (isCollection && !category)) {
      alert("Please fill all required fields.");
      return;
    }

    setLoading(true);

    const folderPath = isCollection
      ? subCategory
        ? `sarees/${section}/${category}/${subCategory}`
        : `sarees/${section}/${category}`
      : `sarees/${section}`;

    const tag = isCollection ? subCategory || category : section;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", cloudinaryUploadPreset);
    formData.append("folder", folderPath);
    formData.append("tags", tag);

    try {
      const res = await fetch(`https://api.cloudinary.com/v1_1/${cloudinaryCloudName}/upload`, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      if (!data.secure_url) {
        throw new Error("Cloudinary upload failed");
      }

      const versionlessUrl = data.secure_url.replace(/\/v\d+\//, "/");
      const finalUrl = `${versionlessUrl}?t=${Date.now()}`;

      // ✅ Save to Google Sheets
      try {
        const sheetRes = await fetch(
          "https://script.google.com/macros/s/AKfycbyDkJ5vt0OOKvnbkF_av4ujih4DWhz7T2C1AloYFVM70HgZikcN5BE3CvT83-ODkO9D/exec",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              name,
              section,
              category: isCollection ? category : "",
              subCategory: isCollection ? subCategory : "",
              url: finalUrl,
              uploadedAt: new Date().toISOString(),
            }),
          }
        );

        const sheetData = await sheetRes.json();
        console.log("Google Sheets response:", sheetData);
        alert("✅ Image uploaded and saved successfully!");
      } catch (sheetErr) {
        console.error("❌ Google Sheets Error:", sheetErr);
        alert("Image uploaded to Cloudinary");
      }
    } catch (err) {
      console.error("❌ Upload Error:", err);
      alert("Image upload failed: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 py-20 max-w-md mx-auto border rounded shadow">
      <h2 className="text-xl text-center font-semibold mb-3">Admin Image Upload</h2>

      <div className="mb-3">
        <label className="block mb-1">Section</label>
        <select
          value={section}
          onChange={(e) => {
            setSection(e.target.value);
            setCategory("");
            setSubCategory("");
          }}
          className="w-full border p-2"
        >
          <option value="new_arrival">New Arrival</option>
          <option value="trending">Trending</option>
          <option value="best_selling">Best Selling</option>
          <option value="pattu_pavada">PattuPavada</option>
          <option value="collection">Collection</option>
        </select>
      </div>

      <div className="mb-3">
        <label className="block mb-1">Image Name</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full border p-2"
          placeholder="Enter image name"
        />
      </div>

      {isCollection && (
        <div className="mb-3">
          <label className="block mb-1">Category</label>
          <select
            value={category}
            onChange={(e) => {
              setCategory(e.target.value);
              setSubCategory("");
            }}
            className="w-full border p-2"
          >
            <option value="">Select category</option>
            {Object.keys(categoryOptions).map((cat) => (
              <option key={cat} value={cat}>
                {cat}
              </option>
            ))}
          </select>
        </div>
      )}

      {isCollection && subCategories.length > 0 && (
        <div className="mb-3">
          <label className="block mb-1">Subcategory</label>
          <select
            value={subCategory}
            onChange={(e) => setSubCategory(e.target.value)}
            className="w-full border p-2"
          >
            <option value="">Select subcategory (optional)</option>
            {subCategories.map((sub) => (
              <option key={sub} value={sub}>
                {sub}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="mb-3">
        <input
          type="file"
          onChange={(e) => setFile(e.target.files[0])}
          className="w-full"
        />
      </div>

      <div className="flex justify-center">
        <button
          onClick={handleUpload}
          disabled={loading}
          className="border border-secondary bg-secondary text-primary font-bold px-4 py-2 rounded"
        >
          {loading ? "Uploading..." : "Upload"}
        </button>
      </div>
    </div>
  );
};

export default UploadForm;
